// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadableLazy } from '@confluence/loadable';

import { LoadingState } from './SpacesDropdownContent';

export const SpacesDropdown = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-global-spaces-dropdown" */ './SpacesDropdown'))
			.SpacesDropdown,
});

export const SpacesDropdownError = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpacesDropdownError" */ './SpacesDropdownError'))
			.SpacesDropdownError,
});

export const SpacesDropdownLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-global-spaces-dropdown" */ './SpacesDropdown'))
			.SpacesDropdown,
	loading: LoadingState,
});

export { EmptyContainer, LoadingContainer } from './SpacesDropdownContent';
export { HoverableItemViewContainer } from './SpacesDropdownItem';
export { SpaceList } from './SpacesDropdownSection';
